



























































































































































































import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createAggregationQueryPayload } from '@/libs/core/+state/models/aggregation-query-payload';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { partyWorkDaysStore } from '@/libs/party-work-days/+state/store';
import { workTasksStore } from '@/libs/work-tasks/+state/store';
import { partiesStore } from '@/libs/parties/+state/store';
import { workTaskEvaluationsGroupsStore } from '@/libs/work-task-evaluation-groups/+state/store';
import { Constants } from '@/constants';
import { workTaskRulesStore } from '@/libs/work-task-rules/+state/store';
import { ApplicationUserModel, BillingTypeEnum, TenantUserModel } from '@/libs/Api';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { applicationUserStore } from '@/libs/user-settings/+state/store';

moment.locale("cs");

@Component({})
export default class DashboardMainPanel extends Page {

    today = new Date();
    user: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail);

    get todayPercentFinished (): number {
        const waiting = this.waitingTodayWorkTaskCount ?? 0;
        const finished = this.doneTodayWorkTaskCount ?? 0;
        const total = waiting + finished;
        return total > 0 ? Math.floor(finished / total * 100) : 0;
    }

    get newClientsPercent (): number {
        const newc = this.newClientsCount ?? 0;
        const acquired = this.todayAcquiredClientsCount ?? 0;
        const total = newc + acquired;
        if (total > 0)
            return total > 0 ? Math.floor(newc / total * 100) : 0;
        else
            return 50;
    }

    get waitingTodayWorkTaskPercent (): number {
        const waiting = this.waitingTodayWorkTaskCount ?? 0;
        const done = this.doneTodayWorkTaskCount ?? 0;
        const total = waiting + done;
        if (total > 0)
            return total > 0 ? Math.floor(waiting / total * 100) : 0;
        else
            return 50;
    }

    get waitingTodayPartyWorkDaysPercent (): number {
        const waiting = this.waitingTodayPartyWorkDaysCount ?? 0;
        const done = this.doneTodayPartyWorkDaysCount ?? 0;
        const total = waiting + done;
        if (total > 0)
            return total > 0 ? Math.floor(waiting / total * 100) : 0;
        else
            return 50;
    }

    get todayPlannedEvaluationsPercent (): number {
        const planned = this.todayPlannedEvaluationsCount ?? 0;
        const eva = this.todayEvaluationsCount ?? 0;
        const total = planned + eva;
        if (total > 0)
            return total > 0 ? Math.floor(planned / total * 100) : 0;
        else
            return 50;
    }

    get newPaidWorkTaskRulesPercent (): number {
        const newpaid = this.newPaidWorkTaskRulesCount ?? 0;
        const activated = this.todayActivatedPaidWorkTaskRulesCount ?? 0;
        const total = newpaid + activated;
        if (total > 0)
            return total > 0 ? Math.floor(newpaid / total * 100) : 0;
        else
            return 50;
    }

    get newFreeWorkTaskRulesPercent (): number {
        const free = this.newFreeWorkTaskRulesCount ?? 0;
        const activated = this.todayActivatedFreeWorkTaskRulesCount ?? 0;
        const total = free + activated;
        if (total > 0)
            return total > 0 ? Math.floor(free / total * 100) : 0;
        else
            return 50;
    }

    get waitingTodayWorkTaskCount(): number {
        return workTasksStore.useGetter(CrudGetter.Count, "WaitingTodayWorkTaskCount") ?? 0;
    }

    get doneTodayWorkTaskCount(): number {
        return workTasksStore.useGetter(CrudGetter.Count, "DoneTodayWorkTaskCount") ?? 0;
    }

    get waitingTodayPartyWorkDaysCount(): number {
        return partyWorkDaysStore.useGetter(CrudGetter.Count, "WaitingTodayPartyWorkDaysCount") ?? 0;
    }

    get doneTodayPartyWorkDaysCount(): number {
        return partyWorkDaysStore.useGetter(CrudGetter.Count, "DoneTodayPartyWorkDaysCount") ?? 0;
    }

    get todayPlannedEvaluationsCount(): number {
        return partiesStore.useGetter(CrudGetter.Count, "TodayPlannedEvaluationsCount") ?? 0;
    }

    get todayEvaluationsCount(): number {
        return workTaskEvaluationsGroupsStore.useGetter(CrudGetter.Count, "TodayEvaluationsCount") ?? 0;
    }

    get newClientsCount(): number {
        return partiesStore.useGetter(CrudGetter.Count, "NewClientsCount") ?? 0;
    }

    get todayAcquiredClientsCount(): number {
        return partiesStore.useGetter(CrudGetter.Count, "TodayAcquiredClientsCount") ?? 0;
    }

    get newPaidWorkTaskRulesCount(): number {
        return workTaskRulesStore.useGetter(CrudGetter.Count, "NewPaidWorkTaskRulesCount") ?? 0;
    }

    get todayActivatedPaidWorkTaskRulesCount(): number {
        return workTaskRulesStore.useGetter(CrudGetter.Count, "TodayActivatedPaidWorkTaskRulesCount") ?? 0;
    }

    get newFreeWorkTaskRulesCount(): number {
        return workTaskRulesStore.useGetter(CrudGetter.Count, "NewFreeWorkTaskRulesCount") ?? 0;
    }

    get todayActivatedFreeWorkTaskRulesCount(): number {
        return workTaskRulesStore.useGetter(CrudGetter.Count, "TodayActivatedFreeWorkTaskRulesCount") ?? 0;
    }

    get tenantUser(): TenantUserModel | null {
        const items = tenantUsersStore.useGetter(CrudGetter.Data, "TenantUser") as TenantUserModel[];
        return items.firstOrDefault();
    }

    mounted () {

        this.loadTenantUser();
        
        this.loadWaitingTodayWorkTaskCount();
        this.loadDoneTodayWorkTaskCount();
        
        this.loadWaitingTodayPartyWorkDaysCount();
        this.loadDoneTodayPartyWorkDaysCount();
        
        this.loadTodayPlannedEvaluationsCount();
        this.loadTodayEvaluationsCount();

        this.loadNewClientsCount();
        this.loadTodayAcquiredClientsCount();

        this.loadNewPaidWorkTaskRulesCount();
        this.loadTodayActivatedPaidWorkTaskRulesCount()

        this.loadNewFreeWorkTaskRulesCount();
        this.loadTodayActivatedFreeWorkTaskRulesCount()

    }

    loadTenantUser () {
        tenantUsersStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TenantUserModel>(undefined, [
            { field: "userId", op: "eq", comparand: this.user.id! }
        ], undefined, false, "TenantUser"))
    }

    loadWaitingTodayWorkTaskCount () {
        workTasksStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "time", op: "gte", comparand: moment().startOf("day").toDate() },
            { field: "time", op: "lte", comparand: moment().endOf("day").toDate() },
            { field: "isProvided", op: "eq", comparand: false },
        ], "", "WaitingTodayWorkTaskCount"));
    }

    loadDoneTodayWorkTaskCount () {
        workTasksStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "time", op: "gte", comparand: moment().startOf("day").toDate() },
            { field: "time", op: "lte", comparand: moment().endOf("day").toDate() },
            { field: "isProvided", op: "eq", comparand: true },
        ], "", "DoneTodayWorkTaskCount"));
    }

    loadWaitingTodayPartyWorkDaysCount () {
        partyWorkDaysStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "day", op: "gte", comparand: moment().startOf("day").toDate() },
            { field: "day", op: "lte", comparand: moment().endOf("day").toDate() },
            { field: "isDone", op: "eq", comparand: false },
        ], "", "WaitingTodayPartyWorkDaysCount"));
    }

    loadDoneTodayPartyWorkDaysCount () {
        partyWorkDaysStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "day", op: "gte", comparand: moment().startOf("day").toDate() },
            { field: "day", op: "lte", comparand: moment().endOf("day").toDate() },
            { field: "isDone", op: "eq", comparand: true },
        ], "", "DoneTodayPartyWorkDaysCount"));
    }

    loadTodayPlannedEvaluationsCount () {
        partiesStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "nextWorkTaskEvaluationDate", op: "gte", comparand: moment().startOf("day").toDate() },
            { field: "nextWorkTaskEvaluationDate", op: "lte", comparand: moment().endOf("day").toDate() }
        ], "", "TodayPlannedEvaluationsCount"));
    }

    loadTodayEvaluationsCount () {
        workTaskEvaluationsGroupsStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "createdAt", op: "gte", comparand: moment().startOf("day").toDate() },
            { field: "createdAt", op: "lte", comparand: moment().endOf("day").toDate() }
        ], "", "TodayEvaluationsCount"));
    }

    loadNewClientsCount () {
        partiesStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "clientStateId", op: "eq", comparand: Constants.PartyStateInterestedId }
        ], "", "NewClientsCount"));
    }

    loadTodayAcquiredClientsCount () {
        partiesStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "acquisitionDate", op: "gte", comparand: moment().startOf("day").toDate() },
            { field: "acquisitionDate", op: "lte", comparand: moment().endOf("day").toDate() }
        ], "", "TodayAcquiredClientsCount"));
    }

    loadNewPaidWorkTaskRulesCount () {
        workTaskRulesStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "catalogueItem.BillingType", op: "eq", comparand: BillingTypeEnum.Charged },
            { field: "workTaskStateId", op: "eq", comparand: Constants.WorkTaskRuleNewId }
        ], "", "NewPaidWorkTaskRulesCount"));
    }

    loadTodayActivatedPaidWorkTaskRulesCount () {
        workTaskRulesStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "catalogueItem.BillingType", op: "eq", comparand: BillingTypeEnum.Charged },
            { field: "activationDate", op: "gte", comparand: moment().startOf("day").toDate() },
            { field: "activationDate", op: "lte", comparand: moment().endOf("day").toDate() }
        ], "", "TodayActivatedPaidWorkTaskRulesCount"));
    }

    loadNewFreeWorkTaskRulesCount () {
        workTaskRulesStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "catalogueItem.BillingType", op: "eq", comparand: BillingTypeEnum.Charged },
            { field: "workTaskStateId", op: "eq", comparand: Constants.WorkTaskRuleNewId }
        ], "", "NewFreeWorkTaskRulesCount"));
    }

    loadTodayActivatedFreeWorkTaskRulesCount () {
        workTaskRulesStore.dispatch(CrudAction.GetCount, createAggregationQueryPayload([
            { field: "catalogueItem.BillingType", op: "eq", comparand: BillingTypeEnum.Charged },
            { field: "activationDate", op: "gte", comparand: moment().startOf("day").toDate() },
            { field: "activationDate", op: "lte", comparand: moment().endOf("day").toDate() }
        ], "", "TodayActivatedFreeWorkTaskRulesCount"));
    }

}

